export default {"src":"/_next/static/media/ic-close-white.fbdc9f03.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};